import React from 'react';
import { Helmet } from 'react-helmet';
import Footer from '../Footer';
import useSiteMetadata from '../SiteMetadata';
import Navbar from '../Navbar';
import '../../styles/all.sass';
import { SITE_TITLE } from '../../constants';

interface Props {
  navbarOff: boolean;
  footerOff: boolean;
}

const TemplateWrapper: React.FC<Props> = ({ navbarOff, footerOff, children }) => {
  const { title, description } = useSiteMetadata();

  return (
    <>
      <Helmet defer={false} defaultTitle={title} titleTemplate={`%s | ${title}`}>
        <html lang="pt" />
        <link rel="apple-touch-icon" sizes="192x192" href={`icons/icon-192x192.png`} />
        <link rel="icon" type="image/png" href={`${process.env.GATSBY_FAVICON}`} sizes="32x32" />
        <meta name="docsearch:version" content="2.0" />
        <meta name="viewport" content="width=device-width,initial-scale=1,shrink-to-fit=no,viewport-fit=cover" />
        <meta name="description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="pt" />
        <meta property="og:site_name" content={title} />
        <meta property="og:image" content={`icons/icon-512x512.png`} />
        <meta property="og:image:alt" content={SITE_TITLE} />
        <meta property="og:image:width" content="512" />
        <meta property="og:image:height" content="512" />
      </Helmet>
      {!navbarOff && <Navbar />}
      <>{children}</>
      {!footerOff && <Footer />}
    </>
  );
};

export default TemplateWrapper;
